var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8024_91668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 6.66675H9.33317C8.62593 6.66675 7.94765 6.9477 7.44755 7.4478C6.94746 7.94789 6.6665 8.62617 6.6665 9.33341V25.3334C6.6665 26.0407 6.94746 26.7189 7.44755 27.219C7.94765 27.7191 8.62593 28.0001 9.33317 28.0001H15.7998M25.3332 14.5001V9.33341C25.3332 8.62617 25.0522 7.94789 24.5521 7.4478C24.052 6.9477 23.3737 6.66675 22.6665 6.66675H19.9998",
    stroke: "#565860",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 4H14.6667C13.1939 4 12 5.19391 12 6.66667C12 8.13943 13.1939 9.33333 14.6667 9.33333H17.3333C18.8061 9.33333 20 8.13943 20 6.66667C20 5.19391 18.8061 4 17.3333 4Z",
    stroke: "#565860",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.033 29.3666C26.9786 29.3666 29.3664 26.9788 29.3664 24.0333C29.3664 21.0878 26.9786 18.7 24.033 18.7C21.0875 18.7 18.6997 21.0878 18.6997 24.0333C18.6997 26.9788 21.0875 29.3666 24.033 29.3666Z",
    fill: "",
    stroke: "#565860",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0332 21.9995V24.5329H25.4998",
    stroke: "#565860",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8024_91668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.1a0324a57719c2cc7e8541b4d92693d5.svg";
export { ForwardRef as ReactComponent };